import MDBox from "components/MDBox"

export default function OeeTable() {
  return (
    <MDBox>Test</MDBox>
  )
}